<template>
    <el-space :size="5">

        <el-tooltip placement="top-end" trigger="hover" :content="$attrs.description" :disabled="!$attrs.description">
            <span>
                {{ column.label }}
            </span>
        </el-tooltip>
        <el-popover v-model:visible="isShow" placement="bottom-end" trigger="click" width="180px">
            <template #reference>
                <el-icon>
                    <el-icon-filter v-if="!isShow" />
                    <el-icon-arrow-up v-else />
                </el-icon>
            </template>
            <div class="filter-container">
                <div v-if="filter.sort">
                    <div class="filter-item" @click="sortChange('ASC')">
                        <el-icon :color="sortStatus == 'ASC' ? '#409EFC' : ''"><el-icon-sort-up /></el-icon><span
                            class="filter-item-label">升序</span>
                    </div>
                    <div class="filter-item" @click="sortChange('DESC')">
                        <el-icon :color="sortStatus == 'DESC' ? '#409EFC' : ''"><el-icon-sort-down /></el-icon><span
                            class="filter-item-label">降序</span>
                    </div>
                    <el-divider style="margin: 5px;" />
                </div>

                <div class="filter-input">
                    <component :is="filterDef.component" v-model="search"></component>
                </div>
                <div style="text-align: right; margin: 0">
                    <el-button size="small" text @click="isShow = false">取消</el-button>
                    <el-button size="small" type="primary" @click="handleSerche">确定</el-button>
                </div>
            </div>
        </el-popover>
    </el-space>
</template>
<script>
import { ref, inject } from 'vue'
import { getColumnFilter } from './columnFilter'
export default {
    props: {
        column: {
            type: Object,
            default: () => ({})
        },
        filter: {
            type: Object
        }
    },
    emits: ['search'],
    setup(props) {
        const isShow = ref(false)
        const search = ref()
        const sortStatus = ref()
        const filterDef = getColumnFilter(props.filter?.name)
        const filterHandler = inject('filterHandler', () => { })
        const handleSerche = () => {
            filterHandler({ column: props.column, filter: filterDef, value: search.value, sort: sortStatus.value })
        }
        const sortChange = (v) => {
            sortStatus.value = v
            // handleSerche()
        }
        return {
            isShow,
            filterDef,
            search,
            sortStatus,
            handleSerche,
            sortChange
        }
    }
}
</script>
<style lang="scss">
.filter-container {
    .filter-input {
        display: flex;
        padding: 5px;
    }

    .filter-item {
        display: flex;
        padding: 5px;
        font-size: var(--el-font-size-extra-small);

        &:hover {
            background-color: #E6E8EB;
        }

        .filter-item-label {
            margin-left: 5px;
        }
    }
}
</style>